import type { CSSObject } from '@emotion/react'
import { Color, Spacing, Typography } from '@opallabs/gem'

export const buttonStyles = (): CSSObject => ({
  color: Color.dark.Text.Accent,
  ...Typography.T300,
  position: 'relative',
  insetBlockStart: Spacing.XS * -1,
  background: 'transparent',
  outline: 'none',
  border: 'none',
  cursor: 'pointer',
  fontFamily: 'inherit',
  marginBlockEnd: Spacing.S * 2,
})
